export default {
    TOP_BAR: 'top_bar',
    BOTTOM_BAR: 'bottom_bar',
};
